import { Component, EventEmitter, OnInit } from '@angular/core';
import {
  LocalStorageService,
  MenuBreadCrumb,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { environment } from 'environments/environment';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { NotificationsService } from 'app/services/notifications.service';
import { Resources } from 'app/models2/maintenance/resources';
import { WorkOrderService } from 'app/services/work-order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { User } from 'app/models2/administration/user';
import { Provider } from 'app/models2/administration/provider';
import { CommentService } from 'app/services/comment.service';

@Component({
  selector: 'app-authorize-work-order',
  templateUrl: './authorize-work-order.component.html',
  styleUrls: ['./authorize-work-order.component.scss'],
})
export class AuthorizeWorkOrderComponent implements OnInit {
  public urlGetTablaResourcesAuthorization: string = `${environment.endpoint}${EndpointDictionary.Resources.RESOURCES_TABLE}`;

  public bodyOrden: WorkOrder = {};
  public view: boolean = false;
  private notificationId: number = this.session.getData('id_notificacion');

  public inventoryModule: boolean =
    this.storage.get<boolean>('inventory_module');
  public resources: Array<Resources> = [{ itemName: '' }];

  //Tabla Recursos
  public reloadResoucesAuthorization = new EventEmitter<any>();
  public paramsResourcesAuthorization: params[] = [
    { id: 'id_orden', value: '0' },
  ];
  public configurationResouces: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
    print: false,
  };
  public columnsResouces: TableColumns<Resources>[] = [
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'name',
        urlParams: [],
        url: `${environment.endpoint}${EndpointDictionary.Item.ITEM_COMBO}`,
      },
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      disregardForAdd: true,
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
  ];

  private orderParams;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Notificaciones',
    },
    {
      name: 'Autorización',
      current: true,
    },
  ];
  constructor(
    private session: SessionService,
    public notificationService: NotificationsService,
    private storage: LocalStorageService,
    private workOrderServices: WorkOrderService,
    private router: Router,
    private commentService: CommentService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.validateBreadcrumb();
    this.activeRoute.queryParamMap.subscribe(async (params) => {
      this.orderParams = { ...params };
    });
  }

  async response(
    $event: Array<boolean | WorkOrder | User[] | Provider[] | Array<Resources>>
  ) {
    this.workOrderServices.authorizeWorkOrder($event, this.notificationId);
  }

  private validateBreadcrumb() {
    let urlBase = this.router.url.split('?')[0];
    if (urlBase && urlBase == '/mantenimiento/orden_trabajo/autorizacion') {
      this.menuBreadCrumb[1] = {
        name: 'Orden de trabajo',
        router: 'mantenimiento/orden_trabajo',
      };
    }
  }

  addComment(workOrder: WorkOrder) {
    workOrder.id = parseInt(this.orderParams.params.id_orden_trabajo);
    this.commentService.addComment(workOrder.id);
  }
}
